/**
 * Compact, swipeable mobile controls for Di Antonio's image-only tiled PDP gallery.
 * Desktop remains a tiled browse view; non-tiled product galleries retain Stockholm's Slick slider.
 */
(function () {
	function initialiseGallery(gallery) {
		if (gallery.dataset.diantonioGalleryReady === 'true') return;

		const list = gallery.querySelector('.diantonio-product-gallery__list');
		const previous = gallery.querySelector('[data-gallery-previous]');
		const next = gallery.querySelector('[data-gallery-next]');
		const status = gallery.querySelector('[data-gallery-status]');
		const mobileQuery = window.matchMedia('(max-width: 989px)');

		if (!list || !previous || !next || !status) return;

		gallery.dataset.diantonioGalleryReady = 'true';

		const slides = () => Array.from(list.querySelectorAll('.product__media-item'));
		const currentIndex = () => {
			const items = slides();
			if (!items.length) return 0;

			return items.reduce((closestIndex, item, index) => (
				Math.abs(item.offsetLeft - list.scrollLeft) < Math.abs(items[closestIndex].offsetLeft - list.scrollLeft)
					? index
					: closestIndex
			), 0);
		};
		const updateControls = () => {
			const items = slides();
			const index = currentIndex();
			const activeOnMobile = mobileQuery.matches;

			previous.disabled = !activeOnMobile || index === 0;
			next.disabled = !activeOnMobile || index === items.length - 1;
			status.textContent = activeOnMobile ? `Image ${index + 1} of ${items.length}` : '';
		};
		const move = (direction) => {
			const items = slides();
			const target = items[currentIndex() + direction];
			if (!target || !mobileQuery.matches) return;

			list.scrollTo({
				left: target.offsetLeft,
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
			});
		};

		previous.addEventListener('click', () => move(-1));
		next.addEventListener('click', () => move(1));
		list.addEventListener('scroll', updateControls, { passive: true });
		mobileQuery.addEventListener('change', updateControls);
		new MutationObserver(() => {
			window.requestAnimationFrame(() => {
				if (mobileQuery.matches) list.scrollTo({ left: 0, behavior: 'auto' });
				updateControls();
			});
		}).observe(list, { childList: true });

		updateControls();
	}

	function initialiseGalleries(root) {
		const galleries = root.matches?.('.diantonio-product-gallery')
			? [root]
			: root.querySelectorAll?.('.diantonio-product-gallery') || [];

		galleries.forEach(initialiseGallery);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initialiseGalleries(document));
	} else {
		initialiseGalleries(document);
	}

	document.addEventListener('shopify:section:load', (event) => initialiseGalleries(event.target));
})();
